const debug = require("debug");
const lucene = require("lucene");

const log = debug("solr-transform");

const fieldMappings = {
    "titel": ["title_txt_de"],
    "text": ["text_txt_de", "title_txt_de"],
    "exakt": ["exact_text_txt"],
    "archiv": ["archive_ss"],
    "band": ["volume_s"],
    "abt": ["section_ss"],
    "person": ["person_ss"],
    "project": ["project_ss"],
    "title": ["title"]
};

const luceneField = (term, field="<implicit>", quoted=true, opts={}) =>
      ({ term, field, quoted, ...opts });

const luceneNode = (left, right, operator, parenthesized) =>
      ({ left, right, operator, parenthesized });

const luceneJunction = (operator, operands) =>
      operands.reduce(
          (junction, opd) => luceneNode(junction, opd, operator, true)
      );

function purifyQuery(query) {
    const copy = JSON.parse(JSON.stringify(query));
    const facetPrefixes = {
        abt: [],
        archiv: []
    }

    prepareFacetPrefixes(copy, facetPrefixes, "abt");
    prepareFacetPrefixes(copy, facetPrefixes, "archiv");

    const q = copy.q ? copy.q : "";
    const facetQueries = Object.keys(copy).filter(k => k !== "q").map(facet => { return luceneField(copy[facet], fieldMappings[facet][0]) });

    return {
        facetPrefixes,
        facetQueries,
        pureQuery: q
    }

    function prepareFacetPrefixes(copy, facetPrefixes, facetType) {
        facetPrefixes[facetType].push("1/") // always include top-level facet values

        if(copy[facetType + "FacetPrefixes"] && copy[facetType + "FacetPrefixes"].length > 0) {
            if (Array.isArray(copy[facetType + "FacetPrefixes"])) {
                facetPrefixes[facetType].push(...copy[facetType + "FacetPrefixes"]);
            }
            else {
                facetPrefixes[facetType].push(copy[facetType + "FacetPrefixes"]);
            }
            delete copy[facetType + "FacetPrefixes"];
        }
    }
}

function transformNode(node) {
    let transformed = { ...node };
    const { field, left, right, term } = transformed;
    const mappedFields = fieldMappings[field] || fieldMappings["text"];

    if (left) {
        transformed.left = transformNode(left);
    }
    if (right) {
        transformed.right = transformNode(right);
    }
    if (field && mappedFields.length === 1) {
        transformed.field = mappedFields[0]
    } else if (field && mappedFields.length > 1) {
        const junct = luceneJunction("OR", mappedFields.map(f => luceneField(term, f)));
        transformed = junct;
    }

    return transformed;
}

module.exports = { transformQuery(query) {
    try {
        if (Object.keys(query).length === 0) {
            return "+type_s:object";
        }

        // extract facet prefixes for separate handling
        const { pureQuery, facetQueries, facetPrefixes } = purifyQuery(query);

        const parsedQuery = lucene.parse(pureQuery);

        const luceneQuery = [];

        luceneQuery.push(transformNode(parsedQuery));

        for (const query of facetQueries) {
            luceneQuery.push(query);
        }

        const consolidatedQuery =  lucene.toString(luceneJunction("AND", luceneQuery))
        return {
            facetPrefixes,
            luceneQuery: consolidatedQuery
        }
    } catch (e) {
        log(e);
        return query;
    }}
}
